export type IRatingStarsProps = {
  rating: number;
};

export const RatingStars: React.FC<IRatingStarsProps> = ({
  rating
}) => {
  const jsx = [];

  // Push full stars onto array.
  for (let i = 0; i < Math.floor(rating); i++) {
    jsx.push(
      <img
        alt="full rating star"
        key={`ystar-${i}`}
        src="/assets/svg/ratings/star-yellow.svg"
      />
    );
  }

  // If needed, push a partial star onto array
  if (rating % 1 !== 0) {
    jsx.push(
      <img
        alt="partial rating star"
        key={'pstar'}
        src="/assets/svg/ratings/star-half.svg"
      />
    );
  }

  // Push empty stars onto the array
  for (let j = 0; j < rating - Math.ceil(rating); j++) {
    // If there is any remainder on the average rating. Go ahead and show the half star
    jsx.push(
      <img
        alt="empty rating star"
        key={`star-${j}`}
        src="/assets/svg/ratings/star.svg"
      />
    );
  }

  return <div className="flex flex-row">{jsx}</div>;
};
